import { render } from "./PhoneInput.vue?vue&type=template&id=19edafae&scoped=true"
import script from "./PhoneInput.vue?vue&type=script&lang=js"
export * from "./PhoneInput.vue?vue&type=script&lang=js"

import "./PhoneInput.vue?vue&type=style&index=0&id=19edafae&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\peles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19edafae"]])

export default __exports__